module.exports = __webpack_public_path__ + "img/banner01.fefa8070.jpg";